/*
 * @Author: Fan
 * @Date: 2020-04-16 17:51:14
 * @description:
 * @LastEditors: Fan
 */
import { selectControlOptions } from "../../../../form/component-schema";
import { DataType } from "../../../../form/typings";
import i18n from "../../../i18n";
export default {
    $id: "radio",
    type: DataType.Object,
    $ref: selectControlOptions.$id,
    properties: {
        widgetType: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        direction: {
            type: DataType.String,
            title: i18n.t('dataitem.WebDirection').toString(),
            default: "horizontal",
        },
        dataLinkage: {
            type: DataType.String,
            title: i18n.t('dataitem.DataLinkage').toString(),
        },
        displaySetting: {
            type: DataType.String,
            title: i18n.t('dataitem.DisplaySetting').toString(),
            default: "showSelected"
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
        readonlyCondition: {
            type: DataType.String,
            title: i18n.t('dataitem.ReadonlyConditions').toString(),
        },
    },
};
